import { render, staticRenderFns } from "./WorkflowTypeChangeMessage.vue?vue&type=template&id=74ba962e"
import script from "./WorkflowTypeChangeMessage.vue?vue&type=script&lang=js"
export * from "./WorkflowTypeChangeMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports